import { render, staticRenderFns } from "./printsupplierOrderIn.vue?vue&type=template&id=a64ab73a&scoped=true&"
import script from "./printsupplierOrderIn.vue?vue&type=script&lang=js&"
export * from "./printsupplierOrderIn.vue?vue&type=script&lang=js&"
import style0 from "./printsupplierOrderIn.vue?vue&type=style&index=0&id=a64ab73a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64ab73a",
  null
  
)

component.options.__file = "printsupplierOrderIn.vue"
export default component.exports